import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown w-250px w-md-600px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "px-7 py-5" }
const _hoisted_3 = { class: "fs-5 text-dark fw-bolder" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_5 = { class: "px-7 py-5" }
const _hoisted_6 = { class: "row mb-7" }
const _hoisted_7 = { class: "col-md-6 form-group" }
const _hoisted_8 = { class: "form-label fw-bold" }
const _hoisted_9 = { class: "col-md-6 form-group" }
const _hoisted_10 = { class: "form-label fw-bold" }
const _hoisted_11 = { class: "row mb-7" }
const _hoisted_12 = { class: "col-md-6 form-group" }
const _hoisted_13 = { class: "form-label fw-bold" }
const _hoisted_14 = { class: "col-md-6 form-group" }
const _hoisted_15 = { class: "form-label fw-bold" }
const _hoisted_16 = { class: "row mb-7" }
const _hoisted_17 = { class: "col-md-6 form-group" }
const _hoisted_18 = { class: "form-label fw-bold" }
const _hoisted_19 = { class: "col-md-6 form-group" }
const _hoisted_20 = { class: "form-label fw-bold" }
const _hoisted_21 = { class: "row mb-7" }
const _hoisted_22 = { class: "col-md-6 form-group" }
const _hoisted_23 = { class: "form-label fw-bold" }
const _hoisted_24 = { class: "d-flex justify-content-end" }
const _hoisted_25 = {
  type: "submit",
  class: "btn btn-sm btn-primary",
  "data-kt-menu-dismiss": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("common.filterOptions")), 1)
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
        model: _ctx.data
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.t("quickInquiry.taskOwner")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "task_owner" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.data.task_owner,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.task_owner) = $event)),
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    clearable: "",
                    placeholder: _ctx.t('common.plsEnter'),
                    "remote-method": _ctx.searchTaskOwnerItems,
                    loading: _ctx.taskOwnerLoading,
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskOwnerOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder", "remote-method", "loading"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.t("quickInquiry.requestedBy")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "requested_by" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.data.requested_by,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.requested_by) = $event)),
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    clearable: "",
                    placeholder: _ctx.t('common.plsEnter'),
                    "remote-method": _ctx.searchRequestedByItems,
                    loading: _ctx.requestedByLoading,
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requestedByOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder", "remote-method", "loading"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("quickInquiry.requestDate")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "request_date" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.data.request_date,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.request_date) = $event)),
                    type: "date",
                    placeholder: _ctx.t('common.pickDate'),
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t("quickInquiry.importance")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "importance" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.data.importance,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.importance) = $event)),
                    clearable: "",
                    placeholder: _ctx.t('common.plsSelect'),
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: _ctx.t('callOutRecords.important'),
                        value: 1
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _ctx.t('callOutRecords.conventional'),
                        value: 2
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _ctx.t('callOutRecords.invalid'),
                        value: 3
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("quickInquiry.closeStatus")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "close_status" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.data.close_status,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.data.close_status) = $event)),
                    clearable: "",
                    placeholder: _ctx.t('common.plsSelect'),
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: _ctx.t('quickInquiry.closeStatusDefaultLabel'),
                        value: "0"
                      }, null, 8, ["label"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.closeStatusOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("quickInquiry.taskSource")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "task_source" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.data.task_source,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.data.task_source) = $event)),
                    clearable: "",
                    placeholder: _ctx.t('common.plsSelect'),
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: _ctx.t('influencerAccount.account'),
                        value: "1"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _ctx.t('influencerAccount.lead'),
                        value: "2"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _ctx.t('influencerAccount.callOut'),
                        value: "3"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _ctx.t('influencerAccount.salesInteraction'),
                        value: "4"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: _ctx.t('influencerAccount.campaign'),
                        value: "5"
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t("quickInquiry.commentTagging")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "comment_tagging" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.data.comment_tagging,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.data.comment_tagging) = $event)),
                    multiple: "",
                    clearable: "",
                    placeholder: _ctx.t('common.plsSelect'),
                    loading: _ctx.commentTaggingLoading,
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentTaggingOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder", "loading"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              type: "reset",
              class: "btn btn-sm btn-white btn-active-light-primary me-2",
              "data-kt-menu-dismiss": "true",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)))
            }, _toDisplayString(_ctx.t("common.reset")), 1),
            _createElementVNode("button", _hoisted_25, _toDisplayString(_ctx.t("common.apply")), 1)
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ])
  ]))
}